// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-05-22
import React, { useState, useCallback } from 'react';
import { IconButton, Dialog } from '@framework-controls/core';
import { IconInfo, IconRemove, IconRemoveAudi } from 'src/content/icons';
import classNames from 'classnames';
import { THEME } from 'src/constants/ThemeNames';
import * as css from './Information.module.scss';
import { ascCtaInteraction, ascPageview } from 'src/helpers/EventHelper/EventHelper';
import { VehicleRec, ascCtaInteractionInput, ascPageviewInput } from 'src/models';
import { strings } from 'src/localization';

interface IProps {
    headerLit: string;
    message?: string;
    children: React.ReactNode;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    /** Optional so the callers that have no theme to hand keep working - they simply get the
     *  shared treatment, which is what they rendered before. */
    theme?: string;
}

const Information = (props: IProps) => {
    const isAudi = props.theme === THEME.AUDI;
    // flag that deterermines if the Dialog is open or closed.
    const [menuOpenFlag, setMenuOpenFlag] = useState(false);

    // Invert the value of the open flag on DialogHandler.
    // This will either set to true (open) if currently false (close)
    // or  flase (close) if current true (open)
    const dialogHandler = useCallback((e: any) => {
        setMenuOpenFlag(!menuOpenFlag);
        if (!menuOpenFlag) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: menuOpenFlag ? 'x' : 'i',
            elementColor: '',
            elementOrder: '',
            elementType: 'item_details',
            elementSubType: 'information_link',
            eventAction: 'click',
            eventActionResult: menuOpenFlag ? 'close' : 'open',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [menuOpenFlag, props.vehicles, props.selectedVehicle]);

    // Audi only: Enter/Space on the close wrapper runs the same close as onClick.
    const closeKeyHandler = useCallback((e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            dialogHandler(e);
        }
    }, [dialogHandler]);

    return (
        <div>
            <IconButton
                id='infoBtn'
                onClick={dialogHandler}>
                <div>
                    <IconInfo />
                </div>
            </IconButton>
            <Dialog
                cssClasses={{
                    content: classNames(css.content, { [css.contentAudi]: isAudi }),
                    paper: classNames(css.paper, { [css.paperAudi]: isAudi }),
                    header: css.LightBoxHeader,
                }}
                isOpen={menuOpenFlag}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={<div>{props.headerLit}</div>}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={dialogHandler}
                onBackDropClick={dialogHandler}
                width='full'
            >
                <div className={classNames(css.headerbox, { [css.headerboxAudi]: isAudi })}>
                    {props.headerLit}
                    {isAudi ?
                        <div className={classNames(css.headerIcon, css.headerIconAudi)}
                            onClick={dialogHandler}
                            onKeyDown={closeKeyHandler}
                            role='button'
                            tabIndex={0}
                            aria-label={strings.Close}>
                            <IconRemoveAudi id='closeBtn'/>
                        </div> :
                        <div className={css.headerIcon}>
                            <IconRemove id='closeBtn' onClick={dialogHandler}/>
                        </div>}
                </div>
                {props.children}
            </Dialog>
        </div>
    );
};

export default Information;
